module.exports = __webpack_public_path__ + "media/images/Successful-purchase-pana-6d62ced58b5deaddd412682c1a190318.png";